// ===========================================================================
// Coding Opportunities V2 (Coding Opportunity Workspace) — Constantes.
//
// IMPORTANTE: Este módulo todavía está EN DESARROLLO. NO debe verse en
// producción. El gating se hace contra `process.env.NODE_ENV`:
//   - `yarn start`  → NODE_ENV = "development"  → CODING_OPS_V2_ENABLED = true
//   - `yarn build`  → NODE_ENV = "production"   → CODING_OPS_V2_ENABLED = false
//
// Como CRA fuerza NODE_ENV en cada comando, no hay env var que alguien pueda
// togglear por error. En el bundle de producción la ruta y el ítem del sidebar
// ni siquiera se registran, y el dead-code-elimination de webpack remueve el
// módulo entero. Cuando V2 esté listo para producción, basta con reemplazar
// esta constante por `true` (o eliminar el gating).
// ===========================================================================

export const CODING_OPS_V2_ENABLED = process.env.NODE_ENV === "development";

export const CODING_OPS_V2_BASE_PATH = "/coding-opportunities-v2";
